import { useState, type FormEvent } from 'react';
import { STANDINGS_WINDOW_STEP } from '../../lib/standingsPosition';

// Barre de navigation dans la fenêtre de classement (embed Arsenal uniquement).
// Permet de remonter / descendre de 10 rangs, de sauter autour d'une position
// précise ou de revenir à sa propre position.

interface StandingsWindowNavProps {
  language: string;
  loading: boolean;
  canGoUp: boolean;
  canGoDown: boolean;
  isShifted: boolean;
  onUp: () => void;
  onDown: () => void;
  onJump: (position: number) => void;
  onReset: () => void;
}

export function StandingsWindowNav({
  language,
  loading,
  canGoUp,
  canGoDown,
  isShifted,
  onUp,
  onDown,
  onJump,
  onReset,
}: StandingsWindowNavProps) {
  const [positionInput, setPositionInput] = useState('');
  const isFr = language === 'fr';

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const position = Number.parseInt(positionInput, 10);
    if (!Number.isFinite(position) || position < 1) return;
    onJump(position);
  };

  return (
    <div className="standings-window-nav mb-3" data-testid="standings-window-nav">
      <div className="d-flex flex-wrap align-items-center gap-2">
        <button
          type="button"
          className="btn btn-outline-primary btn-sm"
          onClick={onUp}
          disabled={loading || !canGoUp}
        >
          ▲ {isFr ? `Voir ${STANDINGS_WINDOW_STEP} plus haut` : `See ${STANDINGS_WINDOW_STEP} higher`}
        </button>
        <button
          type="button"
          className="btn btn-outline-primary btn-sm"
          onClick={onDown}
          disabled={loading || !canGoDown}
        >
          ▼ {isFr ? `Voir ${STANDINGS_WINDOW_STEP} plus bas` : `See ${STANDINGS_WINDOW_STEP} lower`}
        </button>
        {isShifted && (
          <button
            type="button"
            className="btn btn-outline-secondary btn-sm standings-window-nav-reset"
            onClick={onReset}
            disabled={loading}
          >
            {isFr ? 'Ma position' : 'My position'}
          </button>
        )}
        {loading && (
          <span className="spinner-border spinner-border-sm text-primary" role="status" aria-hidden="true"></span>
        )}
      </div>
      <form className="d-flex flex-wrap align-items-center gap-2 mt-2" onSubmit={handleSubmit}>
        <label htmlFor="standings-window-position" className="small mb-0">
          {isFr ? 'Voir autour de la position' : 'See around position'}
        </label>
        <input
          id="standings-window-position"
          type="number"
          inputMode="numeric"
          min={1}
          className="form-control form-control-sm"
          style={{ width: '6rem' }}
          value={positionInput}
          onChange={(e) => setPositionInput(e.target.value)}
          disabled={loading}
        />
        <button
          type="submit"
          className="btn btn-primary btn-sm"
          disabled={loading || !(Number.parseInt(positionInput, 10) >= 1)}
        >
          {isFr ? 'Voir' : 'Go'}
        </button>
      </form>
    </div>
  );
}
